import { DisplayDecorator } from '../../decorators/display-decorator';
import { CustomInjector } from '../../services/custom-injector/custom-injector';
import { ModelOptionsLoaderService } from '../../services/model-options-loader/model-options-loader.service';
import { ValueHelperInstanceToken } from '../../interfaces/value-helper.interface';
import { isDefined } from '../../utilities/is-defined';
import { TextModel } from '../primitive/text.model';
import { AddressModel } from './address.model';
import { CompositeModel } from './composite.model';
import { DropdownModel } from './dropdown.model';

export class MaterialOrderFedexLocationModel extends CompositeModel {
    public street: TextModel;
    public city: TextModel;
    public zipCode: TextModel;
    public statesOfUSA: DropdownModel<TextModel>;
    public country: DropdownModel<TextModel>;

    public constructor(address: AddressModel) {
        super('MaterialOrderFedexLocationModel');

        const injector = CustomInjector.getInjector();
        const valueHelperService = injector.get(ValueHelperInstanceToken);
        const modelOptionsLoader = injector.get(ModelOptionsLoaderService);

        this.street = new TextModel('Street', address.street.value);
        modelOptionsLoader.load(this.street, 'FedExLocations', 'Street');

        this.city = new TextModel('City', address.city.value);
        modelOptionsLoader.load(this.city, 'FedExLocations', 'City');

        this.zipCode = new TextModel('Zip', address.postCode.value);
        modelOptionsLoader.load(this.zipCode, 'FedExLocations', 'Zip');

        if (isDefined(address.statesOfUSA)) {
            this.statesOfUSA = new DropdownModel<TextModel>('State', []);

            this.statesOfUSA.value = valueHelperService
                .getStatesOfUSA()
                .map((vh) => new DisplayDecorator(vh.descText, new TextModel('State', vh.code)));

            if (address.statesOfUSA.selectedEntry?.model?.value) {
                this.statesOfUSA.selectByValue(address.statesOfUSA.selectedEntry.model.value);
            }
            modelOptionsLoader.load(this.statesOfUSA, 'FedExLocations', 'State/province');
        }

        this.country = new DropdownModel<TextModel>('Country', [
            new DisplayDecorator<TextModel>('US', new TextModel('US', 'US')),
        ]);
        modelOptionsLoader.load(this.country, 'FedExLocations', 'Country');
    }
}

export interface FedExRequest {
    Address: {
        City: string;
        StateCode: string;
        Street: string;
        PostalCode: string;
        CountryCode: string;
    };
    Weight: number;
}

export interface GeoLocation {
    Lattitute: number;
    Longitute: number;
}

export interface Address extends GeoLocation {
    Description: string;
    City: string;
    ContactPhone: string;
    StateCode: string;
    Street: string;
    PostalCode: string;
    CountryCode: string;
    IsReseidential: boolean | null;
}

export interface LocationEntry extends WeeklySchedule {
    Distance: number;
    Address: Address;
    IsValid: boolean;
}

export interface TimeRange {
    Begin: string;
    End: string;
}

export interface WeeklySchedule {
    MON?: TimeRange | null;
    TUE?: TimeRange | null;
    WED?: TimeRange | null;
    THU?: TimeRange | null;
    FRI?: TimeRange | null;
    SAT?: TimeRange | null;
    SUN?: TimeRange | null;
}

export interface LocationSearchResponse {
    HomeLocation: GeoLocation;
    DataCollection: LocationEntry[];
}
